import type { CatalogInfo } from '../types/Catalog'

export function applyFiltersToCanonicalUrl(
	canonicalUrl: string,
	dynamicFilter: CatalogInfo['dynamicFilter']
) {
	return dynamicFilter
		? canonicalUrl.split('/').concat(dynamicFilter).join('/')
		: canonicalUrl
}
